<template>
    <div class="tw-panel" :class="{ 'tw-panel-highlight': highlight}">
        <!-- 面板内容（默认插槽） -->
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "tw-panel",
    props: {
        // 鼠标移入时是否高亮显示
        highlight: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style>

</style>